import React from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { markBatchPrinted, markIdCardPrinted } from "../../../store/actions/cardsAction"
import { showAlert } from "../../../store/reducers/alertReducer"

const MarkIDCardPrintedModal = ({ isOpen, toggle, trigger, selectedBatch }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleSubmit = async () => {
    if (!selectedBatch?.uuid) {
      dispatch(showAlert({ text: t("Invalid ID Card uuid"), type: "error" }))
      return
    }

    const payload = {
      id_card_uuid: selectedBatch.uuid,
    }

    try {
      const action = await dispatch(markIdCardPrinted(payload))
      const { statusCode, success, message } = action?.payload || {}

      if (statusCode === 200 && success) {
        dispatch(showAlert({ text: message, type: "success" }))
        toggle()
        trigger()
      } else {
        dispatch(showAlert({ text: message || t("An error occurred"), type: "error" }))
      }
    } catch (error) {
      console.error("Mark printed error:", error)
      dispatch(showAlert({ text: t("Unexpected error"), type: "error" }))
    }
  }

  return (
    <Modal size="lg" isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>{t("Mark ID Card Printed")}</ModalHeader>
      <ModalBody>
        <div className="border rounded p-3">
          <h5 className="mt-3">{t("Are you sure this ID cards is printed?")}</h5>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="d-flex flex-wrap gap-2">
          <button
            type="button"
            className="main_btn disabled-button fit_content px-4"
            onClick={toggle}
          >
            {t("No")}
          </button>
          <button
            type="button"
            className="main_btn fit_content px-4"
            onClick={handleSubmit}
          >
            {t("Yes")}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default MarkIDCardPrintedModal